import React from 'react'

import SettingsIcon from 'Assets/Images/icons/settings'
import { PATHS } from 'Config/Routing/paths'
import { DOCUMENT_FORM } from '../constants'
import BreadcrumbsBackButton from '../../../../Components/BreadcrumbsBackButton'
import StyledBreadcrumbs from '../../../../Components/StyledBreadcrumbs'

const DocumentBreadcrumbs = ({ mode, documentName }) => {
  if (mode === DOCUMENT_FORM.CREATE) {
    return <BreadcrumbsBackButton title={'Add document'} />
  }

  if (mode === DOCUMENT_FORM.EDIT) {
    return (
      <BreadcrumbsBackButton
        title={`Edit ${documentName ? documentName : ''}`}
      />
    )
  }
  return (
    <div>
      <StyledBreadcrumbs
        icon={<SettingsIcon style={{ width: 20 }} />}
        breadcrumbs={[
          {
            label: 'Settings',
            link: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
          },
          { label: 'Signup Identification Documents' },
        ]}
      />
    </div>
  )
}

export default DocumentBreadcrumbs
